import { client } from "./client";

const ROUTES = {
  webhookRequest: ({companydb_id, limit, offset}) => `/webhook_request/?companydb_id=${companydb_id}&offset=${offset}&limit=${limit}`,
};

export const webhookRequest = {
  getData: ({companydb_id, limit, offset}) => {
    return client.get(ROUTES.webhookRequest({companydb_id, limit, offset}));
  },
};